import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useQuery } from '@apollo/client';
import useZipCode from 'global-state/zipCode/useZipCode';
import { GET_CART, GET_FAVORITED_PRODUCT_IDS, GET_USER_FABRIC_FAVORITES } from '@/graphql/queries';

// This hook is used to refetch necessary data after a user logs in or logs out
const useRefetchAfterAuthChange = () => {
  const $ = _c(6);
  const userZipcode = useZipCode();
  const t0 = userZipcode || null;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      variables: {
        zipCode: t0
      }
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    refetch: refetchCart
  } = useQuery(GET_CART, t1);
  const {
    refetch: refetchFavoritedProductIds
  } = useQuery(GET_FAVORITED_PRODUCT_IDS);
  const {
    refetch: refetchUserFabricFavorites
  } = useQuery(GET_USER_FABRIC_FAVORITES);
  let t2;
  if ($[2] !== refetchCart || $[3] !== refetchFavoritedProductIds || $[4] !== refetchUserFabricFavorites) {
    t2 = async () => Promise.all([refetchCart(), refetchFavoritedProductIds(), refetchUserFabricFavorites()]);
    $[2] = refetchCart;
    $[3] = refetchFavoritedProductIds;
    $[4] = refetchUserFabricFavorites;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const refetchAfterAuthChange = t2;
  return refetchAfterAuthChange;
};
export default useRefetchAfterAuthChange;